export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">
              极速影视
            </h3>
            <p className="text-xs text-background-400 leading-relaxed">
              极速影视为您汇集最新上线电影、热播电视剧全集和高清综艺节目单，全部免费在线观看不缓冲，最新电影大全每日更新追剧不停。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { href: '#index', label: '专题合集' },
                { href: '#ranking', label: '热播排行榜' },
                { href: '#carousel', label: '焦点专题' },
                { href: '#updates', label: '最新快讯' },
                { href: '#faq', label: '常见问题' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-xs text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">内容分类</h4>
            <div className="flex flex-col gap-2">
              {['最新电影', '电视剧全集', '综艺节目', '动漫番剧', '纪录片'].map((cat) => (
                <a
                  key={cat}
                  href="#index"
                  className="text-xs text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h4>
            <p className="text-xs text-background-500 leading-relaxed">
              极速影视与多家优质内容方保持合作，持续为用户提供丰富多元的影视资源。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 极速影视 · 最新电影与电视剧全集免费在线观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">
              使用条款
            </a>
            <a href="#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}